import { forwardRef, type ReactNode } from 'react'
import type { FieldError } from 'react-hook-form'
import type { ComponentProps } from 'react'

import { Input } from '@/components/ui'
import { cn } from '@/lib/utils'

export interface AuthFieldProps extends ComponentProps<typeof Input> {
  label: string
  error?: FieldError
  icon?: ReactNode
}

export const AuthField = forwardRef<HTMLInputElement, AuthFieldProps>(function AuthField(
  { label, error, icon, className, ...props },
  ref,
) {
  return (
    <div className="space-y-1.5">
      <label className="block text-xs font-semibold uppercase tracking-wider text-muted-foreground">
        {label}
      </label>
      <div className="relative">
        {icon ? (
          <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground [&>svg]:size-4">
            {icon}
          </span>
        ) : null}
        <Input
          ref={ref}
          className={cn(icon && 'pl-9', error && 'border-destructive focus-visible:border-destructive', className)}
          aria-invalid={Boolean(error)}
          {...props}
        />
      </div>
      {error ? <p className="text-xs text-destructive">{error.message}</p> : null}
    </div>
  )
})